import template from './stVeroButton.template.html';

export default {
  template,
  bindings: {
    ticketOwner: '<',
    idTicket: '<',
    contacts: '<',
    isDisabled: '<',
    onFinished: '&'
  },
controller: class controller {
    constructor($rootScope, $mdDialog, $mdMedia) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.isOpenDialog = false;
      ctrl.$mdMedia = $mdMedia;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.isDisabled = ctrl.isDisabled || false;
      };

      ctrl.openDialog = () => {
        ctrl.isOpenDialog = true;
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {};

      ctrl.onVeroFinished = (status) => {
        ctrl.isOpenDialog = false;
        ctrl.onFinished({ status });
      };
    }
  }
};
